(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobxReact"), require("mobx"), require("React"), require("ReactDOM"), require("ReactRouter"), require("History"), require("weaHrm"));
	else if(typeof define === 'function' && define.amd)
		define(["mobxReact", "mobx", "React", "ReactDOM", "ReactRouter", "History", "weaHrm"], factory);
	else if(typeof exports === 'object')
		exports["weaHrm"] = factory(require("mobxReact"), require("mobx"), require("React"), require("ReactDOM"), require("ReactRouter"), require("History"), require("weaHrm"));
	else
		root["weaHrm"] = factory(root["mobxReact"], root["mobx"], root["React"], root["ReactDOM"], root["ReactRouter"], root["History"], root["weaHrm"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_46__, __WEBPACK_EXTERNAL_MODULE_52__, __WEBPACK_EXTERNAL_MODULE_814__, __WEBPACK_EXTERNAL_MODULE_816__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition